import { Play } from "lucide-react";

/**
 * Video tile that shows a real captured frame instead of a blank black
 * box. Browsers won't paint anything for `preload="metadata"` until a
 * frame is actually decoded — seeking to a fraction of a second on
 * `loadedmetadata` forces that decode, so the video element itself
 * becomes a free "auto-generated" poster/thumbnail with no server-side
 * processing needed. Renders a Play icon on top so it still reads as a
 * video, not a photo.
 */
export function VideoPosterFrame({ src, iconWrapClassName = "p-3", iconClassName = "h-6 w-6" }) {
  return (
    <>
      <video
        src={src}
        className="w-full h-full object-cover"
        muted
        playsInline
        preload="metadata"
        onLoadedMetadata={(e) => {
          try { e.currentTarget.currentTime = 0.75; } catch { /* ignore */ }
        }}
      />
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className={`bg-black/60 rounded-full ${iconWrapClassName}`}>
          <Play className={`${iconClassName} text-white`} fill="white" />
        </div>
      </div>
    </>
  );
}

export default VideoPosterFrame;
